import useStore from './_store';
import { mapState as rootMapState } from 'pinia';
import { mapState } from '@/store/helpers';
import { usePageStore } from '@/store';
import { mapAsyncData } from '../../plugins/asyncData';
import { asyncData } from './asyncData';
import util from '@/common/util.js';
import AttomDesc from '@/components/attom-desc.vue'

export default {
    _getUseStore: useStore,
    i18next: {
        ns: 'md-nbr-local'
    },
    asyncData: mapAsyncData(asyncData),
    data: function() {
        return {
            nbrInfo: null,
            temperatureOptions: null,
            dataCommute: [],
            maxCommute: 0,
        };
    },
    computed: {
        ...rootMapState(usePageStore, {
            "isCensusSubdivision": store => store.page?.censusSubdivision || false,
            "siteId": "siteId"
        }),
        ...mapState({
            "countryConfig": store => store.countryConfig,
            "nbrLocalInfo": store => store.geoGraphic
        }),
        
        isMobileSize() {
            return this.platform.isMobile;
        },
        paddingTop() {
            return (
                (this.isMobileSize ? this.mobileTopSpacing : this.topSpacing) +
                'px'
            );
        },
        marginBottom() {
            return (
                (this.isMobileSize ? this.mobileBtmSpacing : this.btmSpacing) +
                'px'
            );
        },
        
        
        isOccupancyHasData() {
            return this.nbrLocalInfo?.demographics?.households;
        },
        isCommuteScoreHasData() {
            return (
                this.nbrLocalInfo?.walkScore &&
                (this.nbrLocalInfo.walkScore.bikescore > 0 ||
                    this.nbrLocalInfo.walkScore.transitscore > 0 ||
                    this.nbrLocalInfo.walkScore.walkscore > 0)
            );
        },
        isTemperatureHasData() {
            return this.nbrLocalInfo?.demographics?.weather;
        },
        isAllModuleHasData() {
            return (
                this.isOccupancyHasData ||
                this.isCommuteScoreHasData ||
                this.isTemperatureHasData
            );
        }
    },
    beforeMount() {
        window?.siteAppVm?.$EventBus.$emit('canadaLocalInfoConfig', {
            siteid: this.siteId,
            flag: !!this.isAllModuleHasData
        });
    },
    created() {
        this.nbrInfo = this.nbrInfo || {};
        this.temperatureOptions = null;
        this.occupancyOptions = null;
    },
    afterAsyncData() {
        if (!util.isSSRServer) {
            this.setChartData(this.nbrLocalInfo); 
        }
    },
    methods: {
        setChartData(data) {
            if (data.demographics) {
                const demographics = data.demographics;
                if (demographics.weather) {
                    this.setTemperatureOptions(demographics.weather);
                }
            }
            this.onLngNsLoaded('md-nbr-local').then(() => {
                data.walkScore && this.setDataCommute(data.walkScore);
            })
        },
        setTemperatureOptions(data) {
            // Concrete logic is written in Concrete Style Logic 
        },
        setDataCommute(data) {
            // Concrete logic is written in Concrete Style Logic 
        }
    },
    components: {
        AttomDesc
    }
};
